import { connect } from 'react-redux'
import { setActiveModal } from 'registry/actions'
import {
  getAllRegistries,
  getArrivalDate,
  getCurrentShower,
  getHasVisitorPassword,
  getRegistryPhoto,
  getRegistryTitle,
  getRegistryUrlSlug,
  getSearchLevel,
  getShowerInfo,
  getUserOwnsRegistry,
  getRegistryIsBabyRegistry,
} from 'registry/reducers'
import RegistryOverview from './registry-overview'

const mapStateToProps = (state) => ({
  allRegistries: getAllRegistries(state),
  arrivalDate: getArrivalDate(state),
  photoUrl: getRegistryPhoto(state),
  registryTitle: getRegistryTitle(state),
  currentShower: getCurrentShower(state),
  havingShower: getShowerInfo(state).havingShower,
  isEligibleForRegistryDiscount: state.registry.isEligibleForRegistryDiscount,
  isOwner: getUserOwnsRegistry(state),
  registryUrlSlug: getRegistryUrlSlug(state),
  searchLevel: getSearchLevel(state),
  hasVisitorPassword: getHasVisitorPassword(state),
  isBabyRegistry: getRegistryIsBabyRegistry(state),
})

export default connect(mapStateToProps, { setActiveModal })(RegistryOverview)
